// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"05267e01","239":"eedf1d30","455":"04e2136c"}[chunkId] + ".chunk.js";
};